/* Rudix: collapse Globo filter groups by default; keep groups with selected values open.
   Runs on initial Globo paint only — does not fight shopper accordion toggles afterward. */
(function () {
  var applied = false;

  function hasSelected(block) {
    if (!block) return false;
    if (block.querySelector(
      'input:checked, .gf-option-checked, .is-selected, li.selected, .gf-refine-item'
    )) return true;
    return false;
  }

  function collapseTree(root) {
    if (!root) return 0;
    var blocks = root.querySelectorAll('.gf-option-block');
    blocks.forEach(function (block) {
      var title = block.querySelector('.gf-block-title h3, .gf-block-title .h3, [id^="filter-trigger-"]');
      if (hasSelected(block)) {
        block.classList.remove('is-collapsed');
        if (title) title.setAttribute('aria-expanded', 'true');
        return;
      }
      block.classList.add('is-collapsed');
      if (title) title.setAttribute('aria-expanded', 'false');
    });
    return blocks.length;
  }

  function runOnce() {
    if (applied) return true;
    var n = collapseTree(document.getElementById('gf-tree'));
    if (!n) n = collapseTree(document.querySelector('.gf-filter'));
    if (n > 0) {
      applied = true;
      return true;
    }
    return false;
  }

  function boot() {
    if (runOnce()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries += 1;
      if (runOnce() || tries > 60) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { runOnce(); });
})();
